/**
 * 68.6 at L0 and at the table (the owner, Oct 10: pause to command, *"if you need it you need it"*, **on by default**;
 * decision 131): while an order menu is open — the ground's radial or the picker, or the commander's radial at the
 * table (L1) — the host does not advance the Match — the camera and the menu still work, the bots'
 * ticks do not pass, and an order given is stamped at the paused tick, so a replay of a paused game equals its unpaused
 * log. Single player only (28). A presentation setting, always on since decision 147 retired its Lab row and `?pause`;
 * the setter stays for a game or design toggle later.
 */

export const PAUSE_TO_COMMAND_DEFAULT = true;

let override: boolean | null = null;

/** A toggle's override: `null` goes back to the default (on). */
export function setPauseToCommand(on: boolean | null): void { override = on; }

/** Whether the order menu pauses the match: an override, else on. */
export function pauseToCommand(): boolean { return override ?? PAUSE_TO_COMMAND_DEFAULT; }

/** What is open in the host this frame (the order menus that hold the match). */
export interface MenusOpen {
  /** In the commander's view (L1, the table) rather than on the ground. */
  commanding: boolean;
  /** The order radial — the ground's (hold F) or, in the commander's view, the table's (F). */
  radial: boolean;
  /** 68.3's picker (hold Tab; on the ground only). */
  picker: boolean;
}

/**
 * Whether the match holds this frame: an order menu is open and pausing is on. On the ground the radial and the picker
 * hold it; at the table its radial does (the picker is the ground's). The camera and the menus go on either way.
 */
export function menuHoldsMatch(m: MenusOpen, on = pauseToCommand()): boolean {
  if (!on) return false;
  return m.commanding ? m.radial : m.radial || m.picker;
}
